import { Suspense, lazy, ElementType } from "react";
// components
import LoadingScreen from "../components/loading-screen";

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const Login = Loadable(
  lazy(() => import("../pages/auth/AuthLoginForm"))
);
export const Registration = Loadable(
  lazy(() => import("../pages/auth/AuthRegistrationForm"))
);
export const ForgotPassword = Loadable(
  lazy(() => import("../pages/auth/AuthForgotPassword"))
);
export const OtpVerify = Loadable(
  lazy(() => import("../pages/auth/OtpVerify"))
);
export const ChangePassword = Loadable(
  lazy(() => import("../pages/auth/ChangePassword"))
);

export const Dashboard = Loadable(lazy(() => import("../pages/Dashboard")));
export const Deposits = Loadable(lazy(() => import("../pages/Deposits")));
export const Withdraw = Loadable(lazy(() => import("../pages/Withdraw")));
export const Invitations = Loadable(lazy(() => import("../pages/Invitations")));
export const Commissions = Loadable(lazy(() => import("../pages/Commissions")));
export const ThirdPartyAddress = Loadable(
  lazy(() => import("../pages/ThirdPartyAddress"))
);
export const Profile = Loadable(lazy(() => import("../pages/Profile")));

// export const PageFour = Loadable(lazy(() => import("../pages/PageFour")));
// export const PageFive = Loadable(lazy(() => import("../pages/PageFive")));
// export const PageSix = Loadable(lazy(() => import("../pages/PageSix")));

export const Page404 = Loadable(lazy(() => import("../pages/Page404")));
